/**
 * Dialpad - DTMF Dialpad Component
 */

import React from 'react';

const DIGITS = [
  { digit: '1', letters: '' },
  { digit: '2', letters: 'ABC' },
  { digit: '3', letters: 'DEF' },
  { digit: '4', letters: 'GHI' },
  { digit: '5', letters: 'JKL' },
  { digit: '6', letters: 'MNO' },
  { digit: '7', letters: 'PQRS' },
  { digit: '8', letters: 'TUV' },
  { digit: '9', letters: 'WXYZ' },
  { digit: '*', letters: '' },
  { digit: '0', letters: '+' },
  { digit: '#', letters: '' }
];

function Dialpad({ onDigitClick, disabled = false }) {
  return (
    <div className="cx-dialpad">
      {DIGITS.map(({ digit, letters }) => (
        <button
          key={digit}
          className="cx-dialpad__btn"
          onClick={() => onDigitClick(digit)}
          disabled={disabled}
        >
          <span className="cx-dialpad__digit">{digit}</span>
          {letters && (
            <span className="cx-dialpad__letters">{letters}</span>
          )}
        </button>
      ))}
    </div>
  );
}

export default Dialpad;
